import React from "react";
import Row from "react-bootstrap/esm/Row.js";
import "../../TrainingPages.css";

function ModuleOverview(props) {
    /**
     * Component for the top card of the splash page (module description text and thumbnail).
     * @param props: master JSON props passed down from the SplashPage component.
     * @returns: top card containing module overview information and the thumbnail image
     */

    return (
        <Row>
            <div className="col-lg-12 d-flex p-md-1">
                <div className="card dark-bg1-sport w-100">
                    <div className="card-body">
                        <div className="text-center">
                            <h3 className="card-titlext-center head-sport" id="title">{props.title}</h3>
                        </div>
                        <div className="text-center">
                            <h6 className="card-titlext-center head-sport" id="date">Posted on: {props.date}</h6>
                        </div>
                        <div className="text-center">
                            <img className="img-fluid" src={props.thumbnail} alt={`A representation of ${props.title}`} style={{maxHeight: '350px'}}/>
                        </div>
                        <br/>
                        <div className={"head-sport"}>
                            {props.text}
                        </div>
                    </div>
                </div>
            </div>
        </Row>
    );
}

export default ModuleOverview;